import { render, staticRenderFns } from "./InputUI.vue?vue&type=template&id=d8c8b1fe&scoped=true&"
import script from "./InputUI.vue?vue&type=script&lang=js&"
export * from "./InputUI.vue?vue&type=script&lang=js&"
import style0 from "./InputUI.vue?vue&type=style&index=0&id=d8c8b1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c8b1fe",
  null
  
)

export default component.exports